interface AlertData {
  temperatura_min?: number;
  temperatura_max?: number;
  humedad_min?: number;
  humedad_max?: number;
  temperaturas: { sensor: string; temperatura?: number }[];
  humedades: { sensor: string; humedad?: number }[];
}


  function toNumberOrUndefined (value: any): number | undefined {
    if (value === null || value === undefined) return undefined;

    const num = Number(value);
    return isNaN(num) ? undefined : parseFloat(num.toFixed(2));
  };

  /**
   * Extrae y procesa los valores de temperatura y humedad
   * (mínimos, máximos y lecturas por sensor) desde el mensaje de alerta.
   */
  export function extractTemperatureAndHumidityData(rawMessage: any, typeEvent: string): AlertData {
    let temperatura_min: number | undefined;
    let temperatura_max: number | undefined;
    let humedad_min: number | undefined;
    let humedad_max: number | undefined;
    let temperaturas: { sensor: string; temperatura?: number }[] = [];
    let humedades: { sensor: string; humedad?: number }[] = [];

    // Convertir a objeto o array, manejando errores de parseo
    let temp: any;
    try {
      temp = typeof rawMessage === 'string' ? JSON.parse(rawMessage) : rawMessage;
    } catch {
      temp = [];
    }

    // Procesar si es un array válido
    if (Array.isArray(temp) && temp.length > 0) {
      const config = temp[0];
      if (config) {
        const valueMin = toNumberOrUndefined(config.value_min);
        const valueMax = toNumberOrUndefined(config.value_max);

        if (typeEvent === 'humedad' || typeEvent === 'multi-humedad') {
          humedad_min = valueMin;
          humedad_max = valueMax;
        } else if (typeEvent === 'temperatura' || typeEvent === 'multi-temperatura') {
          temperatura_min = valueMin;
          temperatura_max = valueMax;
        }
      }
      // Mapear lecturas por sensor según el tipo de evento
      if (typeEvent === 'humedad' || typeEvent === 'multi-humedad') {
        humedades = temp
          .map((h: any) => ({
            sensor: h.sensor,
            humedad: toNumberOrUndefined(h.value || h.humedad),
          }))
          .filter((h) => h.humedad !== undefined);
      } else if (typeEvent === 'temperatura' || typeEvent === 'multi-temperatura') {
        temperaturas = temp
          .map((t: any) => ({
            sensor: t.sensor,
            temperatura: toNumberOrUndefined(t.value || t.temperatura),
          }))
          .filter((t) => t.temperatura !== undefined);
      }
    }

    return {
      temperatura_min,
      temperatura_max,
      humedad_min,
      humedad_max,
      temperaturas,
      humedades,
    };
  }

  export function extractSingleTemperatureAndHumidityData(
    rawMessage: any,
    event: any,
  ){
    let sensor: string | undefined;
    let valor: number | undefined;
    let valorLimite: number | undefined;

    console.log('--', rawMessage, event.evento, event);

    sensor= rawMessage?.split("|") ? rawMessage.split("|")[0]?.trim().split(":")[1]?.trim() || "" : "";
    valorLimite= rawMessage?.split("|") ? rawMessage.split("|")[1]?.trim().split(/[<>]/)[1]?.trim() || "" : "";


    if (sensor) {
      if (event.evento === 'multi-humedad') {
        valor =
          Number(event.parametros[`BLE Humidity #${sensor}`]) < 100
          ? Number(event.parametros[`BLE Humidity #${sensor}`])
          : Number(event.parametros[`EYE Humidity ${sensor}`]) < 100
            ? Number(event.parametros[`EYE Humidity ${sensor}`])
            : undefined;
      }
      if (event.evento === 'multi-temperatura') {
        valor =
          Number(event.parametros[`BLE Temperature #${sensor}`]) < 180
            ? Number(event.parametros[`BLE Temperature #${sensor}`])
            : Number(event.parametros[`EYE Temperature ${sensor}`]) < 180
              ? Number(event.parametros[`EYE Temperature ${sensor}`])
              : undefined;
      }
    }
    if (valorLimite) {
      valorLimite = Number(valorLimite);
    }

    return {
      sensor,
      valor,
      valorLimite,
    }
  };
